import http from 'plugins/axios';

export default {
    getManagementList(data) {
        return http.get({
            url: '/admin/etp/management/list',
            data
        });
    },

    getManagementProportion(data) {
        return http.get({
            url: '/admin/etp/management/proportion',
            data
        });
    },

    getManagementTrend(data) {
        return http.get({
            url: '/admin/etp/management/trend',
            data
        });
    },
};
